import React from "react";
import { TextField } from "@mui/material";
import GroupBDRBiologists from "../FieldTags/GroupBDRBiologists";
import xplanLabels from "../../util/XplanLabels";
import HistoryLogElement from "./HistoryLogElement";

const newPlan = window.location.pathname === "/xplans/new";

const NIHMSID = ({ nihmsid, handleChange, xplans }) => {
    return (
        <div id="nihmsid" className="planField">
            <GroupBDRBiologists />
            <TextField
                name="nihmsid"
                label={xplanLabels.nihmsid}
                InputLabelProps={{ shrink: true }}
                type="text"
                value={nihmsid ? nihmsid : ""}
                onChange={(e) => handleChange("nihmsid", e.target.value)}
                className="fullLength"
            />
            {!newPlan && <HistoryLogElement xplans={xplans} label={"nihmsid"} />}
        </div>
    );
};

export default NIHMSID;
